import Vue from '../main';

export default {
  getHistoricoEstados(idFormulario) {
    return Vue.$http.get(`${process.env.VUE_APP_ROOT_API}formularios/${idFormulario}/estados`);
  },
}
